module.exports = __webpack_public_path__ + "img/sy-down-close.513ca191.png";